const en = {
  characterCount: 'Characters',
  titleLimitExceeded: 'The event title can contain up to 1,200 characters. Your text is still here.',
  titleHTMLNotAllowed: 'Use plain text for the event title. Your text is still here.',
  commentLimitExceeded: 'A comment can contain up to 60,000 characters. Your full draft is still here.',
  commentMarkupLimitExceeded: 'There is too much formatting. Simplify it before sending. Your full draft is still here.',
  commentPhotoLimitExceeded: 'A comment can contain up to 10 photos. Remove extra photos before sending.',
};
const ru = {
  characterCount: 'Символы',
  titleLimitExceeded: 'В заголовке может быть до 1 200 символов. Весь текст остался в редакторе.',
  titleHTMLNotAllowed: 'Используйте обычный текст для заголовка. Весь текст остался в редакторе.',
  commentLimitExceeded: 'В комментарии может быть до 60 000 символов. Полный черновик остался в редакторе.',
  commentMarkupLimitExceeded: 'Слишком много форматирования. Упростите его перед отправкой. Полный черновик остался в редакторе.',
  commentPhotoLimitExceeded: 'В комментарии может быть до 10 фотографий. Удалите лишние перед отправкой.',
};
const zh = {
  characterCount: '字符',
  titleLimitExceeded: '事件标题最多包含 1,200 个字符。完整文字仍保留在编辑器中。',
  titleHTMLNotAllowed: '事件标题请使用纯文本。完整文字仍保留在编辑器中。',
  commentLimitExceeded: '评论最多包含 60,000 个字符。完整草稿仍保留在编辑器中。',
  commentMarkupLimitExceeded: '格式过多，请简化后再发送。完整草稿仍保留在编辑器中。',
  commentPhotoLimitExceeded: '一条评论最多包含 10 张照片。请删除多余照片后再发送。',
};
const translations = { en, ru, zh };
export default translations;
